/* eslint-disable @typescript-eslint/no-explicit-any */
/** Groups tool call/response pairs from a flat messages array. */
export function groupMessages(messages: any[]) {
  const filtered = messages.filter(
    msg =>
      // 'control' messages (e.g. the "stop" signal) are internal and may
      // briefly surface via the WS stream before the backend drains them.
      msg.role !== 'control' &&
      (msg.role !== 'planner-output' ||
        (Array.isArray(msg.attachments) && msg.attachments.length > 0))
  );
  const grouped: Array<{ type: 'message' | 'tool-pair'; data: any }> = [];
  for (let i = 0; i < filtered.length; i++) {
    const msg = filtered[i];
    if (msg.role === 'tool call') {
      const response =
        filtered.find(
          (m, idx) =>
            idx > i &&
            m.role === 'tool response' &&
            (m as any).toolUseId === (msg as any).toolUseId
        ) ?? null;
      grouped.push({ type: 'tool-pair', data: { call: msg, response } });
    } else if (msg.role === 'tool response') {
      const alreadyPaired = grouped.some(
        g =>
          g.type === 'tool-pair' &&
          (g.data.response as any)?.toolUseId === (msg as any).toolUseId
      );
      if (!alreadyPaired)
        grouped.push({
          type: 'tool-pair',
          data: { call: null, response: msg },
        });
    } else {
      grouped.push({ type: 'message', data: msg });
    }
  }
  return grouped;
}
